export default __webpack_public_path__ + "static/media/2-3_image5.10edd507.png";